// Homepage Content Configuration
// Edit this file to customize all text content on the homepage

export const homepageContent = {
  hero: {
    badge: 'Small Pilot Program',
    headline: 'A Week Away From Screens',
    headlineHighlight: 'for Teens',
    description: 'A small, nature-based program where teens unplug, slow down, and spend time outdoors.',
    primaryButton: 'Request Info',
    secondaryButton: 'Learn More',
    imageAlt: 'Teens spending time outdoors in nature',
    stats: [
      { label: 'One week' },
      { label: 'Max 4 teens' },
      { label: 'Ages 13-16' },
    ],
  },

  whatThisIs: {
    heading: 'What This Is',
    description: 'This is not therapy, treatment, or medical care. It\'s a simple week away from screens in a calm, natural setting.',
    features: [
      {
        title: 'What We Do',
        items: [
          'Time outdoors',
          'Simple daily routine',
          'Movement and activities',
          'Small group setting',
          'No phones during the week'
        ]
      },
      {
        title: 'What This Isn\'t',
        items: [
          'Not therapy or counseling',
          'Not medical treatment',
          'Not a school or educational program',
          'Not a guaranteed fix'
        ]
      }
    ]
  },

  typicalWeek: {
    heading: 'What the Week Looks Like',
    description: 'Simple structure. Nothing rigid or forced.',
    activities: [
      'Morning time outdoors',
      'Meals together',
      'Activities in nature',
      'Group time',
      'Evening wind-down'
    ]
  },

  whoItsFor: {
    heading: 'Who This Might Help',
    description: 'For teens who could use a reset, not those needing professional care.',
    goodFit: [
      'Spending too much time on screens',
      'Feeling stuck or unmotivated',
      'Could use a change of pace',
      'Can participate in a group setting'
    ],
    notFor: [
      'Teens needing medical or mental health treatment',
      'Crisis situations'
    ]
  },

  programDetails: {
    heading: 'Basic Details',
    facts: [
      { label: 'Length', value: 'One week' },
      { label: 'Group Size', value: 'Maximum 4 teens' },
      { label: 'Location', value: 'Nature-based setting (details shared with families)' },
      { label: 'Ages', value: '13-17' }
    ]
  },

  communication: {
    heading: 'Staying in Touch',
    description: 'Here\'s how you\'ll hear from us during the week.',
    features: [
      'Short daily updates',
      'One video call mid-week',
      'A few photos during the week'
    ]
  },

  pricing: {
    heading: 'Dates & Pricing',
    description: 'Dates and pricing are shared after a short conversation to make sure the program is a good fit.',
    note: ''
  },

  disclaimer: {
    text: ''
  }
};

export const heroContent = {
  headline: "A Simple Week Away From Screens for Teens",
  subheadline:
    "A calm, nature-based week away from phones, with a very small group.",
  stats: [
    { label: "One week", icon: "CalendarIcon" as const },
    { label: "Max 4 teens", icon: "UserGroupIcon" as const },
    { label: "Ages 13–16", icon: "UserIcon" as const },
  ],
  primaryCTA: "Request Info",
  secondaryCTA: "Learn More",
};